import React from 'react';
import styled from 'styled-components';
import { Oval } from 'react-loader-spinner';

import { useLexicon } from '../../hooks/useLexicon';

// Same lime + soft track the staff app uses (App.js Suspense fallback).
// Hard-coded here rather than themed so it matches the staff platform's
// loader regardless of theme mode.
const LIME = '#C8FF00';
const TRACK = 'rgba(200, 255, 0, 0.25)';

const PlayerLoader = ({ size = 48, label }) => {
  const l = useLexicon();
  return (
  <Wrap>
    <Oval
      height={size}
      width={size}
      color={LIME}
      visible
      ariaLabel={label || l(1795)}
      secondaryColor={TRACK}
      strokeWidth={4}
      strokeWidthSecondary={4}
    />
  </Wrap>
  );
};

export default PlayerLoader;

export const InlinePlayerLoader = ({ size = 16 }) => {
  const l = useLexicon();
  return (
  <Oval
    height={size}
    width={size}
    color={LIME}
    visible
    ariaLabel={l(1795)}
    secondaryColor={TRACK}
    strokeWidth={5}
    strokeWidthSecondary={5}
  />
  );
};

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
`;
